var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.transportation)?[_vm._l((_setup.availableRoutes),function(route,index){return [_c(_setup.MapRoute,{key:route.polyline,attrs:{"emoji":route.emoji,"travel-mode":route.travelMode,"hide":_setup.shouldHideAlternativeRoute(route.polyline),"polyline-options":{
          path: _setup.decodePolyline(route.polyline),
          geodesic: true,
          strokeColor: _setup.isCurrentRoute(route.polyline) ? '#00A685' : '#D1D5DC',
          strokeOpacity: 1.0,
          strokeWeight: 3,
          zIndex: _setup.isCurrentRoute(route.polyline) ? 10 : 1,
        },"center":{
          lat: route.center.latitude,
          lng: route.center.longitude,
        },"distance":{
          value: route.distance / 1000,
          unit: _setup.tripSettings.distanceUnit,
        }},on:{"marker-click":function($event){return _setup.transportationStore.selectRoute(route)},"polyline-click":function($event){return _setup.transportationStore.selectRoute(route)}},scopedSlots:_vm._u([(_setup.showAlternativeRoutes)?{key:"label",fn:function({ formattedDistance, emoji }){return [_c('div',{staticClass:"flex items-center p-0.5"},[_c('span',{staticClass:"mr-1 rounded bg-primary-100 px-1 text-xs font-bold text-primary-600"},[_vm._v("\n              "+_vm._s(index + 1)+"\n            ")]),_vm._v("\n            "+_vm._s(formattedDistance)+" "+_vm._s(emoji)+"\n          ")])]}}:null],null,true)})]})]:_vm._e(),_vm._v(" "),_vm._l((_setup.allTransportations),function([waypointId, transportations]){return [_vm._l((transportations),function(t){return [(t.route)?_c(_setup.MapRoute,{key:t.route._id,attrs:{"hide":_setup.shouldHideTransportation(t),"hide-label":!_setup.tripSettings.mapSettings.showRouteLabels,"emoji":t.emoji,"travel-mode":t.route.travelMode,"polyline-options":{
          path: _setup.decodePolyline(t.route.polyline),
          geodesic: true,
          strokeColor: '#FFC94A',
          strokeOpacity: 1.0,
          strokeWeight: 3,
        },"center":{
          lat: t.route.center.latitude,
          lng: t.route.center.longitude,
        },"distance":{
          value: t.route.distance / 1000,
          unit: _setup.tripSettings.distanceUnit,
        }},on:{"marker-click":function($event){return _setup.onMarkerClick({ waypointId, transportation: t })},"polyline-click":function($event){return _setup.onMarkerClick({ waypointId, transportation: t })}}}):_vm._e()]})]}),_vm._v(" "),_vm._l((_setup.placeholderRoutes),function([waypointId, route]){return _c(_setup.MapRoute,{key:waypointId,attrs:{"hide":_setup.shouldHidePlaceholderRoute(waypointId),"hide-label":!_setup.tripSettings.mapSettings.showRouteLabels,"emoji":"+","travel-mode":route.travelMode,"polyline-options":{
      path: _setup.decodePolyline(route.polyline),
      geodesic: true,
      strokeColor: '#FFC94A',
      strokeOpacity: 1.0,
      strokeWeight: 3,
    },"center":{
      lat: route.center.latitude,
      lng: route.center.longitude,
    },"distance":{
      value: route.distance / 1000,
      unit: _setup.tripSettings.distanceUnit,
    }},on:{"marker-click":function($event){return _setup.onPlaceholderRouteClick(waypointId)},"polyline-click":function($event){return _setup.onPlaceholderRouteClick(waypointId)}}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }